import React, { CSSProperties } from "react";

import { default as MUIButton } from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const Button = styled(MUIButton)(() => ({
  margin: "5px",
  width: "90px",
  height: "30px",
}));

const BottomGroup = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  marginTop: "30px",
}));

const useStyles = makeStyles(() => ({
  modal: (props: CSSProperties) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: props.position || "absolute",
    background: "rgb(0,0,0,0.8)",
    width: "100%",
    height: "100%",
    bottom: "0px",
    left: "0px",
    borderRadius: props.borderRadius || "15px",
    zIndex: 1000, // Arbitrarly high number since we want modal to overlay on top of everything
  }),
}));

const Warning = styled("div")(() => ({
  color: "#FFFFFF",
  marginBottom: "20px",
  maxWidth: "70%",
  lineHeight: "1.5",
}));

interface ConfirmModalProps {
  confirmButtonText: string;
  confirmText: string | React.ReactElement;
  onCancel: () => void;
  setStatus: React.Dispatch<React.SetStateAction<boolean>>;
  sx?: CSSProperties;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ confirmButtonText, confirmText, onCancel, setStatus, sx }) => {
  const classes = useStyles(sx);

  const submit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setStatus(true);
  };

  return (
    <div className={classes.modal}>
      <Warning>{confirmText}</Warning>
      <div>
        <BottomGroup>
          <Button size="small" variant="contained" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" size="small" variant="contained" onClick={submit}>
            {confirmButtonText}
          </Button>
        </BottomGroup>
      </div>
    </div>
  );
};

export default ConfirmModal;
